import React from "react";
import Flatpickr from "react-flatpickr";
import { ReactComponent as CalendarIcon } from "../assets/icons/calendar.svg";
import moment from "moment";

function Datepicker({ align, date, setDate, className }) {
  const options = {
    mode: "range",
    static: true,
    monthSelectorType: "static",
    dateFormat: "d M, Y",
    defaultDate: [date.startDateLabel, date.endDateLabel],
    prevArrow:
      '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M5.4 10.8l1.4-1.4-4-4 4-4L5.4 0 0 5.4z" /></svg>',
    nextArrow:
      '<svg class="fill-current" width="7" height="11" viewBox="0 0 7 11"><path d="M1.4 10.8L0 9.4l4-4-4-4L1.4 0l5.4 5.4z" /></svg>',
    onReady: (selectedDates, dateStr, instance) => {
      instance.element.value = dateStr.replace("to", "-");
      const customClass = align ? align : "";
      instance.calendarContainer.classList.add(`flatpickr-${customClass}`);
    },
    onChange: (selectedDates, dateStr, instance) => {
      instance.element.value = dateStr.replace("to", "-");
      if (selectedDates.length === 2) {
        console.log({
          startDate: moment(selectedDates[0]).format("YYYY-MM-DD"),
          endDate: moment(selectedDates[1]).format("YYYY-MM-DD"),
        });
        setDate((prevState) => ({
          ...prevState,
          startDateLabel: selectedDates[0],
          endDateLabel: selectedDates[1],
          startDate: moment(selectedDates[0]).format("YYYY-MM-DD"),
          endDate: moment(selectedDates[1]).format("YYYY-MM-DD"),
        }));
      }
    },
  };

  return (
    <div className="w-full">
      <div className="relative">
        <Flatpickr
          className={`form-input w-full rounded-none font-medium text-gray-500 hover:text-gray-600 focus:border-gray-300 ${className}`}
          options={options}
        />
        <div className="pointer-events-none absolute inset-0 left-auto flex items-center">
          <CalendarIcon className="mr-3" />
        </div>
      </div>
    </div>
  );
}

export default Datepicker;
